const _     = require('underscore');
const guid  = require('./guid');

module.exports = meta => {
  const id = guid();
  const ext_ids = { doi: meta.doi };
  const article = _.pick(meta,
    "issn",
    "eissn",
    "issue",
    "title",
    "volume",
    "journal",
    "abstract",
    "pagination"
  );
  article.year = parseInt(meta.year);
  article.journal_abbrev = meta.journal;
  article.authors = meta.authors.map(a => a.standard_name || a);
  return { id, ext_ids, article };
};
